import TiersApi from '@/API/marketing/tiers-api'

export default {
  namespaced: true,
  state: {
    tags: [],
    availableTags: [],
    tiers: [],
    tiersFetched: false,
    tiersLoading: false,
    selectedTier: null,
    ageGroup: [],
  },

  getters: {
    tags: (state: any) => state.tags,
    ageGroup: (state: any) => state.ageGroup,
    availableTags: (state: any) => state.availableTags,
    selectedTier: (state: any) => state.selectedTier,
    orderSpendTags: (state: any) => state.tags.filter((tag: any) => ['spend', 'order'].includes(tag.type)),
    tiersFetched: (state: any) => state.tiersFetched,
    tiers: (state: any) => state.tiers,
    tiersLoading: (state: any) => state.tiersLoading,
  },

  mutations: {
    SET_TIERS(state: any, tiers: any) {
      state.tiers = tiers
      state.tiersFetched = true
    },
    SET_AGE_GROUP(state: any, ageGroup: any) {
      state.ageGroup = [...ageGroup]
    },
    SET_TAGS(state: any, tags: any) {
      state.tags = tags
    },
    SET_AVAILABLE_TAGS(state: any, availableTags: any) {
      state.availableTags = availableTags
    },
    TRIGGER_LOADER(state: any, loader: boolean) {
      state.tiersLoading = loader
    },
    SET_TIER_FILTER(state: any, tier: any) {
      state.selectedTier = tier
    },
    SET_TIERS_FETCHED(state: any, fetched: boolean) {
      state.tiersFetched = fetched
    },
  },

  actions: {
    async UPDATE_AGE_GROUP(context: any, payload: any) {
      const groups = context.getters.ageGroup
      const index = groups.findIndex((group: any) => payload.id === group.id)
      if (index > -1) {
        groups[index] = { ...payload }
        context.commit('SET_AGE_GROUP', groups)
      }
    },
    async FETCH_TIERS(context: any) {
      if (context.state.tiersLoading) {
        return []
      }
      if (context.state.tiersFetched) {
        return { tiers: context.state.tiers, tags: context.state.tags }
      }
      context.commit('TRIGGER_LOADER', true)
      try {
        const { tiers, tags, age_groups } = await TiersApi.getList()
        context.commit('SET_TIERS', tiers)
        context.commit('SET_TAGS', tags)
        context.commit('SET_AGE_GROUP', age_groups)
      } catch (err) {
        console.error(err)
      } finally {
        context.commit('TRIGGER_LOADER', false)
      }
      return { tiers: context.state.tiers, tags: context.state.tags }
    },
  },
}
